import { getRequest, postRequest } from "NetworkCall";
import { INSTANCE_URL } from "Constants";
export const SPONSORSINSIGHT_TOTAL_NOOFSPON = "SPONSORSINSIGHT_TOTAL_NOOFSPON";

const sponsorsinsightnoofsponcount = (session, callback) => {
  var url = `${INSTANCE_URL}/api/v2/analytics?type=sponinsinoofsponcnt`;
  return (dispatch) => {
    postRequest(
      url,
      {
        type: "sponinsinoofsponcnt",
        eventid: session.eventid,
      },
      session,
      dispatch,
      (response) => {
        var data = response;

        dispatch({
          type: SPONSORSINSIGHT_TOTAL_NOOFSPON,
          payload: { count: data.count },
        });
        callback({
          error: 0,
          data: "Analytics Attendees Attendee Message Threads Fetched !",
        });
      },
      (error) => {
        callback({ error: 1, data: null });
      }
    );
  };
};

export { sponsorsinsightnoofsponcount };
